import imageCompression from 'browser-image-compression'

// 压缩选项
const options = {
  maxSizeMB: 1, // 最大文件大小
  maxWidthOrHeight: 1920, // 最大宽度或高度
  useWebWorker: true, // 使用Web Worker
  fileType: 'image/jpeg', // 输出文件类型
  initialQuality: 0.8, // 初始压缩质量
}

// 获取文件扩展名
const getFileExtension = (filename: string): string => {
  return filename.slice((filename.lastIndexOf('.') - 1 >>> 0) + 2)
}

// 压缩图片
export const compressImage = async (file: File): Promise<File> => {
  try {
    // 如果文件小于1MB，不压缩
    if (file.size < 1024 * 1024) {
      console.log('文件小于1MB，不进行压缩')
      return file
    }

    console.log('压缩前文件大小:', (file.size / 1024 / 1024).toFixed(2), 'MB')
    const compressedFile = await imageCompression(file, options)
    console.log('压缩后文件大小:', (compressedFile.size / 1024 / 1024).toFixed(2), 'MB')

    // 如果压缩后仍然大于1MB，进行二次压缩
    if (compressedFile.size > 1024 * 1024) {
      console.log('文件仍然大于1MB，进行二次压缩')
      const secondOptions = {
        ...options,
        maxSizeMB: 1,
        initialQuality: 0.7
      }
      const secondCompressedFile = await imageCompression(file, secondOptions)
      console.log('二次压缩后文件大小:', (secondCompressedFile.size / 1024 / 1024).toFixed(2), 'MB')
      
      // 保持原始文件扩展名
      const extension = getFileExtension(file.name)
      return new File([secondCompressedFile], file.name, {
        type: `image/${extension === 'jpg' ? 'jpeg' : extension}`
      })
    }

    // 保持原始文件扩展名
    const extension = getFileExtension(file.name)
    return new File([compressedFile], file.name, {
      type: `image/${extension === 'jpg' ? 'jpeg' : extension}`
    })
  } catch (error) {
    console.error('图片压缩失败:', error)
    return file
  }
}

// 压缩多张图片
export const compressImages = async (files: File[]): Promise<File[]> => {
  return Promise.all(files.map(file => compressImage(file)))
} 